import { render, staticRenderFns } from "./animation-satellite.vue?vue&type=template&id=a13b4584&scoped=true&"
import script from "./animation-satellite.vue?vue&type=script&lang=js&"
export * from "./animation-satellite.vue?vue&type=script&lang=js&"
import style0 from "./animation-satellite.vue?vue&type=style&index=0&id=a13b4584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13b4584",
  null
  
)

export default component.exports